import React from "react"
import "../styles/lab.scss"
import MainLayout from "../layouts/MainLayout"
import { Heading1 } from "../components/utils/Typography"
import Breadcrumb from "../components/utils/Breadcrumb"
import "../styles/global.scss"

function Lab() {
  return (
    <div className="lab">
      <MainLayout>
        <Breadcrumb
          arr={[
            { name: "Home", path: "/" },
            { name: "Lab", path: "/lab" },
          ]}
        />
        <Heading1
          heading="Codefumes Lab"
          subheading="empowering the open source"
        />
        <div className="container mt-4 pt-3">
          <div className="fs-5">
            At codefumes, we believe that most of the digital insfrastructure in
            the world, is powered by Open Source Software. To contribute in this
            gigantic industry, we have dedicated department called Codefumes
            Lab. The purpose of Lab is to plan, design, develop and keep
            updating various open source software projects. If you're a
            developer, you can contribute to our open source projects via github
            pull requests. All the public repositories in our github are open
            for contribution.
          </div>
          <br />
          <br />
          <div className="fs-3 text-center text-purple">
            Open Source Projects are Coming Soon! <br /> 😉
          </div>
        </div>
      </MainLayout>
    </div>
  )
}

export default Lab
